import React, { useState, useEffect } from 'react'
import { Card, CardBody } from "reactstrap"
import { Link } from 'react-router-dom'
import { Button, Spin, Pagination, message, Input as IndputAntd } from 'antd'
import MaterialCodeTable from './MaterialCodeTable'
import UseDebounce from '../../helpers/UseDebounce'
import MaterialCodeModal from './MaterialCodeModal'
import { getListMaterials } from "../../../services/api/apiSku"

const MaterialCodePage = () => {
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(1)
    const [listMaterialCode, setListMaterialCode] = useState([])
    const [name, setName] = useState('')
    const [isOpenCreate, setIsOpenCreate] = useState(false)

    const debounceName = UseDebounce(name, 1000)

    useEffect(() => {
        fetchMaterialCode()
    }, [page, limit, debounceName])

    const fetchMaterialCode = async () => {
        try {
            setLoading(true)
            const payload = {
                page, limit,
                object: "BrandTag"
            }

            if (!!name) payload.name = name.trim()

            const { data: res = {} } = await getListMaterials(payload)
            const { data, success, message: mess } = res

            if (!success) throw new Error(mess)

            setListMaterialCode(data.data)
            setTotal(data.total)

        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleChangeName = (e) => {
        setName(e.target.value || '')
        setPage(1)
    }

    const handlePageChange = (page, pageSize) => {
        setPage(page)
    }

    const handleChangePageSize = (page, pageSize) => {
        setLimit(pageSize)
        setPage(1)
    }

    const handeShowModalCreate = () => {
        setIsOpenCreate(true)
    }

    const handeCloseModalCreate = () => {
        setIsOpenCreate(false)
    }

    return (
        <div className='material-code-page'>
            <div className="BackWrapper">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <Link to='/tag-brands'><i className='fa fa-chevron-left mr-1' />Tag Brands Inventory Management</Link>
                        <h1 className='card-title mt-2'>Material Code</h1>
                    </div>
                    <Button
                        type="primary"
                        disabled={loading}
                        onClick={handeShowModalCreate}
                    >
                        Add new
                    </Button>
                    <MaterialCodeModal
                        isOpen={isOpenCreate}
                        disabled={loading}
                        title="New Material Code"
                        onClose={handeCloseModalCreate}
                        onOpen={handeShowModalCreate}
                        reload={fetchMaterialCode}
                    />
                </div>
            </div>
            <Card>
                <CardBody>
                    <div className="material-code-filter mb-3">
                        <div className="d-flex align-items-center">
                            <div className="itemFilter mr-3">
                                <IndputAntd
                                    placeholder='Type to search...'
                                    onChange={handleChangeName}
                                    value={name || ''}
                                    allowClear
                                    style={{ width: '300px' }}
                                />
                            </div>
                        </div>
                    </div>
                    <Spin spinning={loading} tip={'Đang lấy dữ liệu...'} size='large'>
                        <MaterialCodeTable
                            data={listMaterialCode}
                            reload={fetchMaterialCode}
                        />
                    </Spin>
                    <div className="DataPagination d-flex justify-content-end Pagination">
                        <Pagination current={page} total={total} pageSize={limit} onChange={handlePageChange}
                            className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100', '200']}
                            onShowSizeChange={handleChangePageSize}
                        />
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default MaterialCodePage